<template>

    <hr class="w-48 h-1 mx-auto bg-gray-200 border-0 rounded">

</template>
